<template>
  <div>
    <Toast position="bottom-right" group="br" />
    <!-- <div class="container-fluid bg-light"> -->
    <div class="form col-lg-10 mx-auto bg-white">
      <h6 class="text-center mt-2 mb-3 heading">
        Register Providers of your company
      </h6>
      <form class="col-lg-11 mx-auto" @submit.prevent="newDriver()">
        <div class="inputs d-flex flex-wrap mx-auto">
          <div class="form-group col-sm-6 col-lg-3">
            <input
              type="text"
              class="form-control"
              name="firstname"
              v-model="ProviderData.Firstname"
              placeholder="Provider first name"
              required
            />
          </div>
          <div class="form-group col-sm-6 col-lg-3">
            <input
              type="text"
              class="form-control"
              name="lastname"
              v-model="ProviderData.Lastname"
              placeholder="Provider last name"
              required
            />
          </div>
          <div class="form-group col-sm-6 col-lg-2">
            <select
              class="form-control"
              v-model="ProviderData.Gender"
              name="gender"
              id="gender"
              required
            >
              <option disabled value>--Gender--</option>

              <option value="M">Male</option>

              <option value="F">Female</option>
            </select>
          </div>
          <div class="form-group col-sm-6 col-lg-4">
            <input
              type="email"
              class="form-control"
              name="email"
              v-model="ProviderData.email"
              placeholder="Provider email"
              required
            />
          </div>

          <div class="form-group col-sm-6 col-lg-4 col-md-6 col-11 col-12">
            <select
              class="form-control"
              v-model="ProviderData.selector"
              @change="getCode()"
              name="phoneCodes"
              id="phoneCodes"
              required
            >
              <option
                v-for="phoneCode in phoneCodes"
                v-bind:value="phoneCode.code"
                :key="phoneCode.code"
              >
                {{ phoneCode.code }} --
                {{ phoneCode.name }}
              </option>
            </select>
          </div>

          <div
            class="input-group mb-3 col-lg-4 col-md-6 col-11 col-sm-6 col-12"
          >
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{
                currentCode
              }}</span>
            </div>

            <input
              type="number"
              class="form-control mt-0"
              placeholder="Phone number"
              name="phone"
              id="phone"
              v-model="ProviderData.phone"
              autocomplete="autocomplete_off_hack_xfr4!k"
              aria-describedby="basic-addon1"
              required
            />
          </div>

          <div class="text-center col-lg-4">
            <button type="submit" name="newDriver" class="btn btn-primary">
              Add Provider
              <span
                v-if="addProviderClicked"
                class="spinner-border spinner-border-sm ml-2 my-auto"
              ></span>
            </button>
          </div>
        </div>
      </form>

      <div v-if="showTable" class="added-Providers col-lg-10 mx-auto">
        <div class="table-container card my-3 col-lg-12 p-0 mx-auto">
          <table class="table col-lg-12">
            <thead class="bg-success">
              <tr>
                <th>#</th>
                <th>Provider Name</th>
                <th>Provider Email</th>
                <th>Provider Contacts</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="Provider in Providers" :key="Provider">
                <td>{{ Provider.DriverID }}</td>
                <td>{{ Provider.Firstname + " " }}{{ Provider.Lastname }}</td>
                <td>{{ Provider.Email }}</td>
                <td>{{ Provider.Contacts }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import phoneCodes from "../../user-management/phoneCodes.json";
import axios from "axios";
const url = "https://bookinga.herokuapp.com/api/v1/company/provider";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      currentCode: "+250",
      phoneCodes: phoneCodes.countries,
      showTable: false,
      location: "",
      name: "",
      clicksCounter: 0,
      addProviderClicked: false,
      ProviderData: {
        Firstname: "",
        phone: "",
        Gender: "",
        Lastname: "",
        email: "",
        driverId: "",
        selector: "+250",
      },
      Providers: [],
    };
  },
  created() {},
  methods: {
    getCode() {
      this.currentCode = this.ProviderData.selector;
    },    
    newDriver() {
      this.addProviderClicked = true;
      if (
        this.ProviderData.phone != "" ||
        this.ProviderData.email != "" ||
        this.ProviderData.Gender == "" ||
        this.ProviderData.FirstName != "" ||
        this.ProviderData.Lastname != ""
      ) {
        axios
          .post(
            url,
            {
              firstName: this.ProviderData.Firstname,
              lastName: this.ProviderData.Lastname,
              email: this.ProviderData.email,
              gender: this.ProviderData.Gender,
              telephone: this.currentCode + this.ProviderData.phone,
            },
            config
          )
          .then((res) => {
            this.addProviderClicked = false;
            if (res.data.message == "Ticket provider registered successfully") {
              this.$toast.add({
                severity: "success",
                summary: "Success",
                detail: "Provider saved successfully",
                group: "br",
                life: 5000,
              });
              this.clicksCounter++;
              this.Providers.push({
                no: this.clicksCounter,
                Firstname: this.ProviderData.Firstname,
                Lastname: this.ProviderData.Lastname,
                gender: this.ProviderData.Gender,
                Email: this.ProviderData.email,
                DriverID: this.ProviderData.driverId,
                Contacts: this.currentCode + this.ProviderData.phone,
              });
              this.ProviderData.Firstname = "";
              this.ProviderData.Lastname = "";
              this.ProviderData.email = "";
              this.ProviderData.Gender = "";
              this.ProviderData.phone = "";
              this.showTable = true;
              return;
            } else {
              return this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: res.data.message,
                group: "br",
                life: 5000,
              });
            }
          })
          .catch((error) => {
            this.addProviderClicked = false;
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: error.message,
              group: "br",
              life: 5000,
            });
          });
      } else {
        this.$toast.add({
          severity: "info",
          summary: "Information",
          detail: "All the fields are required",
          group: "br",
          life: 5000,
        });
      }
    },
  },
};
</script>

<style scoped>
@import 'sharedStylesReg.css';
.form {
    border-radius: 10px;
    height: 84.2vh;
}

button.btn.btn-primary {
    width: 100%;
    background: #0069d9;
    font-size: 13px;
}
</style>
